import BaseApi from "./base-api";
import React, { ReactNode } from "react";
import { AvailableApis } from "../routes";
import { Menu } from "antd";
import { SidebarApiBaseMeta } from "../../../@types/route-mapping-api";

type SidebarMenuItemApiCallbackProps = {
  title: () => ReactNode;
};

type SidebarMenuItemApiParams = {
  title: () => ReactNode;
};

type SidebarMenuItemApiMeta = SidebarApiBaseMeta;

export default class SidebarMenuItemApi extends BaseApi<
  AvailableApis,
  SidebarMenuItemApiMeta,
  SidebarMenuItemApiCallbackProps,
  ReactNode
> {
  private params: SidebarMenuItemApiParams;
  constructor(params: SidebarMenuItemApiParams) {
    super("sidebar-menu-item-api");
    this.params = params;
  }

  public use({ history, hasRoles }: SidebarMenuItemApiMeta) {
    const { title } = this.params;
    const { path, requiredRoles, external } = this.getOwner();

    if (hasRoles(requiredRoles).oneOf())
      return (
        <Menu.Item
          key={path as string}
          onClick={() => {
            if (external) {
              window.location.assign(path as string);
            } else {
              history.push(path as string);
            }
          }}
        >
          {title()}
        </Menu.Item>
      );
    return null;
  }
}
